import { withDependencies } from '@wix/thunderbolt-ioc'
import {
	LayoutChangeObserverSymbol,
	RenderDoneObserverSymbol,
	ILayoutDoneService,
	ILayoutChangeObserver,
	IRenderDoneObserver,
} from '@wix/thunderbolt-symbols'

export const LayoutDoneService = withDependencies<ILayoutDoneService>(
	[RenderDoneObserverSymbol, LayoutChangeObserverSymbol],
	(renderDoneObserver: IRenderDoneObserver, layoutChangeObserver: ILayoutChangeObserver) => {
		const service: ILayoutDoneService = {
			registerToRenderDone: (callback, options = { once: false }, isPublicCallback = false) => {
				return renderDoneObserver.subscribe(callback, options, isPublicCallback)
			},
			registerToComponentsLayoutChange: (callback, options = { once: false }, isPublicCallback = false) => {
				return layoutChangeObserver.subscribe(callback, options, isPublicCallback)
			},
			unregisterToLayoutDone(callbackId) {
				renderDoneObserver.unsubscribe(callbackId)
				layoutChangeObserver.unsubscribe(callbackId)
			},
			isRenderPending: renderDoneObserver.isRenderPending,
			setRenderPending: renderDoneObserver.setRenderPending,
			addToChangedComponents: layoutChangeObserver.addToChangedComponents,
			addToChangedComponentsAndNotify: layoutChangeObserver.addToChangedComponentsAndNotify,
			tryNotifyComponentsChanged: layoutChangeObserver.notifyIfNeeded,
			enableLayoutDone: layoutChangeObserver.enableLayoutChangeObserver,
			dispatchNextLayoutDoneBeforePaint: layoutChangeObserver.dispatchNextLayoutDoneBeforePaint,
		}
		return service
	}
)
